import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const fetchRewardOrderHistory = createAsyncThunk("fetchRewardOrderHistory", async (id, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`order/${id}/status-history`);

		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const RewardOrderHistorySlice = createSlice({
	name: "RewardOrderHistorySlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardOrderHistory.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(fetchRewardOrderHistory.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchRewardOrderHistory.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default RewardOrderHistorySlice.reducer;
